import { useCookies } from '@vueuse/integrations/useCookies';
import type { CookieSetOptions } from 'universal-cookie';

enum CookieKeys {
  UserKey = '_user',
  AccessTokenKey = '_accessToken',
  RefreshTokenKey = '_refreshToken'
}

const defaultCookieOptions: CookieSetOptions = {
  path: '/',
  sameSite: 'strict'
};

export function setUserCredentials(user: string, accessToken: string, refreshToken: string): void {
  const cookies = useCookies(null);
  cookies.set(CookieKeys.UserKey, user, defaultCookieOptions);
  cookies.set(CookieKeys.AccessTokenKey, accessToken, defaultCookieOptions);
  cookies.set(CookieKeys.RefreshTokenKey, refreshToken, defaultCookieOptions);
}

export function getAccessToken(): string {
  const cookies = useCookies(null);
  return cookies.get(CookieKeys.AccessTokenKey);
}

export function getRefreshToken(): string {
  const cookies = useCookies(null);
  return cookies.get(CookieKeys.RefreshTokenKey);
}

export function setAccessToken(token: string) {
  const cookies = useCookies(null);
  cookies.set(CookieKeys.AccessTokenKey, token, defaultCookieOptions);
}

export function clearCookies(): void {
  const cookies = useCookies(null);
  cookies.remove(CookieKeys.UserKey, defaultCookieOptions);
  cookies.remove(CookieKeys.AccessTokenKey, defaultCookieOptions);
  cookies.remove(CookieKeys.RefreshTokenKey, defaultCookieOptions);
}
